<template>
  <div>
    <div v-if="selectedRunner" class="mb-2 appointed_block">
      <p>Выбран курьер для назначения заявок</p>
      <div class="flex justify-content-between">
        <div>
          <p><strong>{{ runnerName }}</strong></p>
          <p>количество выбранных заявок: <strong>{{ selectedOrders.orders.length }}</strong></p>
          <p>на общую сумму: <strong>{{ selectedOrders.totalSum }}</strong></p>
        </div>
        <div v-if="selectedOrders.orders.length">
          <LoadingButton
            title="Назначить"
            className="btn btn-xs btn-success"
            :loading="btnLoading"
            :color="$constants.LOADING_COLOR"
            :onClick="() => appointOrders()"
          />
        </div>
      </div>
    </div>
    <div class="card hover" v-for="o in orders" v-if="o.is_active !== 0">
      <div class="card-body p-2">
        <div class="flex justify-content-between">
          <div class="flex align-items-center"><span class="badge badge-info mr-1">{{
              moment(o.delivery_date, 'DD.MM')
            }}</span>
            <v-popover
              :auto-hide="true"
            >
              <button type="button" class="btn btn-xs btn-outline-success mr-1">
                Перенос
              </button>
              <template slot="popover">
                <select class="form-control" v-model="o.new_delivery_date">
                  <option
                    v-for="date in getChangeDateOptions(o.delivery_date)"
                    :key="date.date"
                    :value="date.date"
                  >{{ date.text }}
                  </option
                  >
                </select>
                <LoadingButton
                  title="Сохранить"
                  className="btn btn-xs btn-success"
                  :loading="updateBtnLoading"
                  :color="$constants.LOADING_COLOR"
                  :onClick="() => updateDeliveryDate(o)"
                />
              </template>
            </v-popover>
            <strong class="mr-1">{{ mixinPrintOrderNum(o.id) }}</strong>
            <span>{{ $AllProjects[o.site_id]?.name ?? 'не определен' }}</span>
          </div>
          <p class="text-muted">{{ moment(o.created_at, 'DD.MM') }}</p>
        </div>
        <div class="flex justify-content-between">
          <div>
            <p>{{ o.client_name ?? o?.client?.name ?? 'Имя не указано' }}</p>
            <template
              v-for="phone in (o.order_phones?.length ? o.order_phones : o.phones.map((p) => {return {...p, phone:{phone: (''+p.full_phone).substring(2)}}}))">
              <p v-if="phone.phone"><a class="phone_num"
                                       :href="`tel:${mixinPrintPhone('00' + phone.phone.phone, true)}`">{{
                  mixinPrintPhone('00' + phone.phone.phone)
                }}</a>
              </p>
            </template>
          </div>
          <div>
            <button @click="noAnswerPhoneCall(o.id, '')" class="btn btn-xs btn-outline-warning">
              Недозвон <span
              v-if="o.extra_options.noAnswerCallOrder">({{ o.extra_options.noAnswerCallOrder }})</span>
            </button>
          </div>
        </div>
        <div class="mb-1">
          <p>{{ o.address }}</p>
          <p v-if="o.extra_options.address_details">{{ o.extra_options.address_details }}</p>
          <RunnerSalaryRate :rate="o?.extra_options?.salary_rate ?? 0"/>
        </div>
        <div class="comment_block">
          <div>
            <template v-for="(comment) in (o.extra_options?.comments_for_runner ?? [])">
              <p v-html="comment.text"/>
              <p class="comment_author_date">{{ moment(comment.created_at, 'DD.MM HH:mm') }}</p>
            </template>
          </div>
          <div>
            <template v-for="(comment) in (o.comment ?? [])">
              <p v-html="comment.text"/>
              <p class="comment_author_date">{{ moment(comment.created_at, 'DD.MM HH:mm') }}</p>
            </template>
          </div>
          <div class="mt-1 mb-1 flex justify-content-between">
            <v-popover
              :auto-hide="true"
              popoverClass="reject_reason_popover"
            >
              <button type="button" class="btn btn-xs btn-outline-info">
                Вопрос менеджеру
              </button>
              <template slot="popover">
                <div>
                  <input
                    type="text"
                    placeholder="Ваш вопрос"
                    v-model="o.manager_request"
                    class="form-control"
                  />
                  <LoadingButton
                    title="Отправить"
                    type="button"
                    className="btn btn-xs btn-info"
                    :loading="updateBtnLoading"
                    :color="$constants.LOADING_COLOR"
                    :onClick="() => updateOrderByAction(o, 'addManagerRequest')"
                  />
                </div>
              </template>
            </v-popover>
            <v-popover
              :auto-hide="true"
              popoverClass="reject_reason_popover"
            >
              <button type="button" class="btn btn-xs btn-outline-info">
                Добавить комментарий
              </button>
              <template slot="popover">
                <div>
                  <input
                    type="text"
                    placeholder="Ваш комментарий"
                    v-model="o.new_comment"
                    class="form-control"
                  />
                  <LoadingButton
                    title="Сохранить"
                    className="btn btn-xs btn-info"
                    :loading="updateBtnLoading"
                    :color="$constants.LOADING_COLOR"
                    :onClick="() => updateOrderByAction(o, 'addComment')"
                  />
                </div>
              </template>
            </v-popover>
          </div>
          <div class="mt-1 mb-1">
            <UploadFile :order-id="o.id" type="runnersFile"/>
          </div>
        </div>
        <div :class="`tr_status_${storeStatusByOrders[o.id]?.status}`">
          <table class="table mt-0 table-sm">
            <tr v-for="d in o.details">
              <td>{{ d.new_drug.title }}
                <div class="flex flex_gap">
                <span>
                  <v-popover
                    trigger="click"
                    :delay="{ show: 100, hide: 100 }"
                  >
                      <i @click="loadDrugImage(d.drug_id, o.site_id)" class="icon-fa icon-fa-image pointer"/>
                      <template slot="popover">
                        <div>
                          <clip-loader
                            :loading="imageLoading[d.drug_id]"
                            :color="$constants.LOADING_COLOR"
                            size="20px"
                          />
                          <template v-if="!imageLoading[d.drug_id]">
                            <div v-if="drugImages?.[d.drug_id]?.[o.site_id]">
                              <img
                                :src="drugImages[d.drug_id][o.site_id].image"/>
                            </div>
                            <div v-else>
                              Фото не найдено
                            </div>
                          </template>
                        </div>
                      </template>
                    </v-popover>
                </span>
                  <div v-if="d.new_drug.cool" class="alert cool_condition m-0">
                    Доставка с хладогеном
                  </div>
                </div>
                <div v-if="+d.new_drug.pack_set !== 1">
                  <p>препарат комплектный</p>
                  <p>1компл. = {{ +d.new_drug.pack_set }}уп.</p>
                </div>
              </td>
              <td align="right"><strong> x {{ d.qty / (d.new_drug.pack_set || 1) }}<span
                v-if="+d.new_drug.pack_set !== 1"> к.</span></strong></td>
            </tr>
            <tr>
              <template v-if="o.pay_method === 3">
                <td colspan="2" align="right" class="price_td"><strong>Заявка оплачена</strong></td>
              </template>
              <template v-else>
                <td colspan="1">
                  <FastCallBackRequest :order="o"/>
                </td>
                <td align="right" class="price_td"><strong>{{
                    showCurrencyPrices ? o.currency_id_price : o.price
                  }}</strong></td>
              </template>
            </tr>
          </table>
        </div>
        <div class="flex justify-content-between">
          <div>
            <template v-if="selectedRunner">
              <label>
                <input @change="(e) => updateSelectedOrders(e, o)" type="checkbox"> выбрать заявку
              </label>
            </template>
            <template v-if="runnerId">
              <LoadingButton
                title="сбросить заявку"
                className="btn btn-xs btn-outline-info"
                :loading="btnLoading"
                :color="$constants.LOADING_COLOR"
                :onClick="() => resetOrders(o)"
              />
            </template>
          </div>
          <div class="flex">
            <v-popover
              :auto-hide="true"
              popoverClass="reject_reason_popover"
            >
              <button type="button" class="btn btn-xs btn-outline-warning">
                Отменить
              </button>
              <template slot="popover">
                <div>
                  <input
                    type="text"
                    placeholder="Причина отказа"
                    v-model="o.reject_reason"
                    class="form-control"
                  />
                  <LoadingButton
                    title="Подтвердить"
                    className="btn btn-xs btn-warning"
                    :loading="updateBtnLoading"
                    :color="$constants.LOADING_COLOR"
                    :onClick="() => rejectOrder(o)"
                  />
                </div>
              </template>
            </v-popover>
            <LoadingButton
              v-if="runnerId"
              title="Доставить"
              className="ml-1 btn btn-xs btn-success"
              :loading="btnLoading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => setClosed(o)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import Popover from 'vue-js-popover'
import RunnerSalaryRate from "@/views/orders/RunnerSalaryRate.vue";
import UploadFile from "@/components/files/UploadFile.vue";
import FastCallBackRequest from "@/views/components/runners/FastCallBackRequest.vue";

export default {
  props: ['orders', 'divisionId', 'runnerId', 'storeStatusByOrders', 'runnerName', 'selectedRunner', 'updateOrders'],
  components: {
    FastCallBackRequest,
    UploadFile,
    RunnerSalaryRate,
    LoadingButton,
    Popover,
  },
  data() {
    return {
      imageLoading: {},
      drugImages: {},
      updateBtnLoading: false,
      showCurrencyPrices: false,
      btnLoading: false,
      selectedOrders: {
        orders: [],
        totalSum: 0
      }
    }
  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce(
        (acc, p) => {
          acc[p.id] = {...p}
          return acc
        },
        {}
      )
    },
  },
  created() {
    this.showCurrencyPrices = this.$AllDivisions[this.divisionId]?.settings?.currency_id ?? false;
    if (this.showCurrencyPrices) {
      this.orderCurrencyAlias = this.$AllCurrencies[this.$AllDivisions[this.divisionId].settings.currency_id]?.currency ?? null;
    }
  },
  methods: {
    async loadDrugImage(drugId, siteId) {
      this.$set(this.imageLoading, drugId, true);
      if (this.drugImages?.[drugId]?.[siteId]) {
        this.imageLoading[drugId] = false;
        return;
      }
      try {
        const {data} = await api.post('/new/drugs/infoType', {
          types: ['projectInfo'],
          drug_id: drugId,
          project_id: siteId
        });
        if (data.success) {
          const drugInfo = this.drugImages?.[drugId] ?? {};
          drugInfo[siteId] = {
            image: data.image_full ?? data.image
          }
          this.$set(this.drugImages, drugId, drugInfo);
        } else {
          toastr['warning'](data.message, 'Ошибка!')
        }
      } catch (e) {
        toastr['warning']('Ошибка сервера!')
      }
      this.imageLoading[drugId] = false;
    },
    async setClosed(order) {
      this.btnLoading = true
      const {data} = await api.post('/runners/orders/updateOrders', {
        type: 'setClosed',
        selected_orders: [order.id],
      })
      if (data.success) {
        await this.updateOrders(true);
        toastr['success']('Сохранено')
      } else {
        toastr['warning'](data.message || 'Ошибка!')
      }
      this.btnLoading = false
    },
    async resetOrders(order = null) {
      this.btnLoading = true
      const {data} = await api.post('/runners/orders/updateOrders', {
        type: 'resetOrders',
        payMethod: 'pre_paid',
        selected_orders: [order.id],
        runnerId: this.runnerId,
      })
      if (data.success) {
        await this.updateOrders(true);
        toastr['success']('Сохранено')
      } else {
        toastr['warning'](data.message || 'Ошибка!')
      }
      this.btnLoading = false
    },
    async appointOrders() {
      if (!this.selectedOrders.orders.length) {
        toastr['warning']('Выберите заявки!')
        return
      }
      this.btnLoading = true
      const {data} = await api.post('/runners/orders/updateOrders', {
        type: 'assignOrders',
        selected_orders: this.selectedOrders.orders,
        runnerId: this.selectedRunner,
        payMethod: 'pre_paid'
      })
      if (data.success) {
        await this.updateOrders(true);
        this.selectedOrders.orders = [];
        this.selectedOrders.totalSum = 0;
        toastr['success']('Сохранено')
      } else {
        toastr['warning'](data.message || 'Ошибка!')
      }
      this.btnLoading = false
    },
    updateSelectedOrders(e, order) {
      if (e.target.checked) {
        this.selectedOrders.orders.push(order.id);
        this.selectedOrders.totalSum += +order.price;
      } else {
        this.selectedOrders.orders = this.selectedOrders.orders.filter((o) => o !== order.id);
        this.selectedOrders.totalSum -= +order.price;
      }
    },
    async updateOrderByAction(order, action) {
      switch (action) {
        case 'addManagerRequest':
          console.log(order.manager_request);
          if (!order.manager_request) return;
          this.updateBtnLoading = true;
          const {data} = await api.post('/tasks/new', {
            type: 'order_message_runner_to_manager',
            order_id: order.id,
            message: order.manager_request,
          });
          if (data.success) {
            toastr['success']('Отправлено!');
            order.manager_request = null;
          } else {
            toastr['warning'](data.message ?? 'Ошибка сервера');
          }
          this.updateBtnLoading = false;
          return;
        case 'addComment':
          if (!order.new_comment) return;
          break;
      }
      this.updateBtnLoading = true
      const {data} = await api.post('/orders/updateOrderByAction', {
        action,
        order_id: order.id,
        comment: order.new_comment
      })
      if (data.success) {
        const index = this.orders.findIndex((o) => o.id === order.id);
        this.orders[index].comment.push({
          text: order.new_comment,
          created_at: moment().format('YYYY-MM-DD HH:mm:00')
        });
        this.orders[index].new_comment = null;
        toastr['success']('Обновлено')
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.updateBtnLoading = false
    },
    async updateDeliveryDate(order) {
      this.updateBtnLoading = true
      const {data} = await api.post('/runners/orders/updateOrders', {
        type: 'updateDeliveryDate',
        order: {
          id: order.id,
          date: order.new_delivery_date,
          oldDate: order.delivery_date
        }
      })
      if (data.success) {
        order.delivery_date = order.new_delivery_date
        toastr['success']('Обновлено')
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.updateBtnLoading = false
    },
    getChangeDateOptions(deliveryDate) {
      let dates = []
      for (let index = 1; index < 30; index++) {
        const ddate = moment().add(index, 'days')
        dates.push({
          date: ddate.format('YYYY-MM-DD'),
          text: ddate.format('DD.MM')
        })
      }
      return dates
    },
    moment: function (date, format = 'DD.MM.YYYY', object = false) {
      if (!date) return
      const objectDate = moment(date)
      if (object) return objectDate
      return objectDate.format(format)
    },
    async rejectOrder(order) {
      if (!order.reject_reason) {
        toastr['warning']('Укажите причину отказа')
        return
      }
      this.updateBtnLoading = true
      const {data} = await api.post('/runners/orders/updateOrders', {
        type: 'rejectOrder',
        payMethod: 'pre_paid',
        order: {
          id: order.id,
          reason: order.reject_reason,
          expenses: order.reject_expenses
        }
      })
      if (data.success) {
        const index = this.orders.findIndex((o) => o.id === order.id);
        this.orders[index].is_active = 0;
        toastr['success']('Обновлено')
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.updateBtnLoading = false
    },
    async noAnswerPhoneCall(orderId, phone) {
      let {data} = await api.store('/runners/orders/updateNoAnswerCalls', {
        order_id: orderId,
        action: 'noAnswerCallOrder'
      })
      if (data.success) {
        toastr['success']('Обновлено')
        const index = this.orders.findIndex(
          o => o.id === orderId
        )
        if (this.orders[index]) {
          if (!this.orders[index].extra_options.noAnswerCallOrder) {
            this.orders[index].extra_options.noAnswerCallOrder = 0
          }
          ++this.orders[index].extra_options.noAnswerCallOrder
        }
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
    },
  }
}

</script>

<style scoped>
.appointed_block {
  position: sticky;
  top: 70px;
  z-index: 9;
  background-color: white;
  border: 1px solid lightgray;
  padding: 10px;
}

table.table td.price_td {
  font-size: 20px;
}

.card.hover {
  margin-bottom: 20px !important;
  box-shadow: -5px 14px 24px -8px rgba(102, 102, 102, 1);
}

p {
  margin-bottom: 2px;
}

.comment_author_date {
  text-align: right;
}

.cool_condition {
  padding: 0 5px;
  color: white;
  background-color: #0094c1;
  border-color: #013b4e;
}

table.table td {
  padding: 3px;
  font-size: 14px;
}

.tr_status_1 {
  background-color: #FCC4C4;
}

.tr_status_2 {
  background-color: #F9E5AE;
}

.tr_status_3 {
  background-color: #BCE2F4;
}

.comment_block {
  border-top: 1px solid lightgray;
}

.flex_gap {
  gap: 10px;
}
</style>
